export default [

     {
          path: '/disruption-impact',
          name: 'DisruptionImpact',
          component: () => import("@/views/Page/DisruptionImpact/DisruptionImpact.vue"),
           meta: {
               title: '#Default# | DisruptionImpact',
          },
     }
];